<template>
  <div id="doctor-list">
    <div class="row topactionform">
      <div class="col-xs-5" style="padding-right: 0">
        <div class="smalltitle">Store File </div>
      </div>
      <div class="col-xs-7">
        <div class="row">
          <div class="col-xs-10"></div>
          <div class="col-xs-2">
            <button class="btn light btn-block informbtn" @click.prevent="modal = true"><i
                class="fa fa-plus"></i> Upload File
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="blockcont">
      <ul class="itemlisttable  ptemr-list">
        <li class="itemlisthead">
          <div class="item-name" style="width: 50% !important;">File Name</div>
          <div class="item-dob">Expiration Date</div>
          <div class="item-action itemaction" style="text-align: right !important; float: right !important;">Action</div>
        </li>

        <li v-for="(file, index) in oldFiles" :key="file.id">
          <div class="item-name" style="width: 50% !important;">
            <img v-if="file.link && file.type.substr(0, 6) === 'image/'"
                 :src="formatLink(file.link)" width="40" height="auto"/>
            <span class="td-name-file-name">
                                            <a href="javascript:void(0)" @click.prevent="showFile(index)"
                                               class="editFileName">{{file.name}}</a></span>
          </div>
          <div class="item-dob">
            {{ file.expirationDate }}
          </div>
          <div class="itemaction" style="text-align: right !important; float: right !important;">
            <a href="javascript:void(0)" @click.prevent="showFile(index)"
               title="View file"><i class="fa fa-edit"></i> View</a>
            <a :href="formatLink(file.link)" title="Download file"><i
                class="fa fa-download"></i>
              Download</a>
            <a href="javascript:void(0)" @click="deleteOldFile(index)"
               title="Delete file"><i
                class="fa fa-times"></i> Delete</a>
          </div>
        </li>
      </ul>
    </div>

    <modal class="skintestblock" v-model="modal" :append-to-body="true" :backdrop="false" size="max">
      <div slot="header">
        <h4 class="smalltitle" slot="header">Upload file</h4>
        <button type="button" class="close" @click.prevent="modal = false" title="Close">×</button>
      </div>
      <div class="block-body">
        <div class="blockcont">
          <div class="prolabel">Expiration date</div>
          <div class="profield">
            <date-picker placeholder="Expiration date"
                         v-model="expirationDate"
                         format="MM/DD/YYYY" :clearable="true" lang="en"></date-picker>
          </div>
        </div>
        <div class="example-full">
          <div class="row">
            <div class="col-md-12">
              <div class="blockcont block-image">
                <div class="upload-drop-zone drop-active" id="drop-zone-application-bio"
                     @click="triggerSelectFile"></div>
                <label for="file" class="btn btn-lg btn-primary hide" id="selectFileLicense">Select
                  Files</label>
                <div style="text-align:center">
                  <button class="btn" v-if="!$refs.uploadLicense || !$refs.uploadLicense.active"
                          @click.prevent="clickUpload()">Upload
                  </button>
                  <button type="button" class="btn btn-danger" v-else
                          @click.prevent="$refs.uploadLicense.active = false">
                    Stop Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="upload">
            <div class="">
              <table class="table table-hover">
                <thead>
                <tr class="signed-form">
                  <th class="td-name">UPLOADED FILES</th>
                  <th class="td-action" style="text-align: right !important;">ACTIONS</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(file, index) in files" :key="file.id">
                  <td class="td-name">
                    <div class="filename">
                      <img v-if="file.thumb" :src="file.thumb" width="40" height="auto"/>
                      {{file.name}}
                    </div>
                  </td>
                  <td class="td-action" style="text-align: right !important;">
                    <div class="td-action-process">
                      <div class="progress" v-if="!file.error">
                        <div
                            :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}"
                            role="progressbar" :style="{width: file.progress + '%'}">
                          &nbsp;&nbsp;{{file.progress}}%
                        </div>
                      </div>
                      <div class="error-text" v-if="file.error">{{file.response.msg}}</div>
                    </div>
                    <div class="td-action-delete" style="width: 10%">
                                        <span class="delete-new-file"
                                              @click.prevent="$refs.uploadLicense.remove(file)"><i
                                            class="fa fa-times"></i></span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="example-foorer">
              <file-upload
                  name="file"
                  class="btn btn-primary dropdown-toggle hide"
                  :post-action="postAction"
                  :multiple="multiple"
                  :directory="directory"
                  :headers="headers"
                  :drop="drop"
                  :add-index="addIndex"
                  v-model="files"
                  :data="dataRequest"
                  @input-filter="inputFilter"
                  @input-file="inputFile"
                  ref="uploadLicense">
              </file-upload>

            </div>
          </div>
        </div>
      </div>
    </modal>
    <preview-pdf
        v-if="previewPdf.modal"
        :linkPreview="previewPdf.link"
        @updateModal="previewPdf.modal = $event">
    </preview-pdf>
  </div>
</template>

<script>
import PreviewPdf from '../../global/PreviewPdf'
import DatePicker from 'vue2-datepicker'
import config from '@/config'
import axios from '@/client'
import store from '@/store/store'
import moment from 'moment'
import Common from '../mixins/Common'

const baseUrl = config.baseUrl
export default {
  name: 'StoreFile',
  mixins: [Common],
  components: {
    FileUpload: VueUploadComponent,
    DatePicker,
    PreviewPdf
  },
  data () {
    return {
      modal: false,
      processing: false,
      files: [],
      oldFiles: [],
      postAction: baseUrl + '/store-file/file-upload',
      dataRequest: {},
      addIndex: false,
      headers: {},
      autoCompress: 1024 * 1024,
      minSize: 0,
      uploadAuto: false,
      isOption: false,
      drop: true,
      dropDirectory: false,
      multiple: false,
      directory: false,
      accept: 'image/png,image/gif,image/jpeg,image/webp,application/pdf',
      extensions: 'gif,jpg,jpeg,png,webp,pdf',
      previewPdf: {
        modal: false,
        link: ''
      },
      expirationDate: ''
    }
  },
  mounted () {
    this.loadDataFile()
  },
  methods: {
    clickUpload () {
      this.$refs.uploadLicense.active = true
    },
    loadDataFile () {
      axios.get('/store-file/file-upload', {
        params: {}
      }).then(response => {
        if (response.data.s === 200) {
          let data = response.data.data
          this.oldFiles = []
          data.map(file => {
            this.oldFiles.push({
              _id: file._id,
              id: file._id,
              name: file.name,
              link: '/store-file/download-file/?view=true&name=' + file.serverPath,
              linkDownload: '/store-file/download-file/?name=' + file.serverPath,
              type: file.mimeType || '',
              createdAt: file.createdAt,
              expirationDate: file.expirationDate
            })
          })
        } else {
          this.alertError(response.data.msg)
        }
      }).catch(e => {
        this.alertError(e.message)
      })
    },
    showFile (index) {
      let file = this.oldFiles[index]
      this.previewPdf.link = this.formatLink(file.link)
      this.previewPdf.modal = true
    },
    deleteOldFile (index) {
      let file = this.oldFiles[index]
      axios.delete(`/store-file/file-upload/`, {
        params: {
          fileId: file.id
        }
      }).then(response => {
        if (response.data.s === 200) {
          this.oldFiles.splice(index, 1)
        } else {
          this.alertError(response.data.msg)
        }
      }).catch(e => {
        this.alertError(e.message)
      })
    },
    triggerSelectFile () {
      $('#selectFileLicense').click()
    },
    async inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
        this.dataRequest.expirationDate = moment(this.expirationDate).format('MM/DD/YYYY')
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file)
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = ''
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob
        }
      }
      if (!newFile && oldFile) {
        if (oldFile.success && oldFile.response.data.id) {
          // remove
        }
      }
    },
    // add, update, remove File Event
    inputFile (newFile, oldFile) {
      this.dataRequest.expirationDate = this.expirationDate ? moment(this.expirationDate).format('MM/DD/YYYY') : ''
      if (newFile && !oldFile) {
      }
      if (newFile && oldFile) {
        // update
        if (newFile.active && !oldFile.active) {
          // beforeSend
          if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
            this.$refs.uploadLicense.update(newFile, { error: 'size' })
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
        }
        if (newFile.error && !oldFile.error) {
          // error
          let response = newFile.response
          if (response.s === 400) {

          }
        }
        if (newFile.success && !oldFile.success) {
          // create file
          if (store.state.timeOutLogin) {
            clearTimeout(store.state.timeOutLogin)
          }
          let timeOut = setTimeout(function () {
            store.commit('setOpenModalLogin', true)
          }, 540000)
          store.commit('setWorkingStatus', timeOut)
          if (newFile.response.s === 200) {
            let data = newFile.response.data
            let vm = this
            vm.loadDataFile()
            vm.$refs.uploadLicense.remove(newFile)
            this.dataRequest.expirationDate = ''
            this.modal = false
          } else {
            newFile = this.$refs.uploadLicense.update(newFile, { error: 'size' })
          }
        }
      }

      if (!newFile && oldFile) {
        // remove

      }
      // Automatically activate upload
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (this.uploadAuto && !this.$refs.uploadLicense.active) {
          this.$refs.uploadLicense.active = true
        }
      }
    },
    formatLink (link) {
      if (link.includes('data:image')) {
        return link
      }
      return baseUrl + link
    }
  }
}
</script>

<style scoped>
.td-action-process {
  width: 80%;
  float: left;
}

.td-action-delete {
  width: 20%;
  float: left;
}

.td-action-delete i {
  color: red;
}

.progress-bar {
  color: #333;
}

.td-action .itemaction > a {
  margin-left: 10px;
  color: #3e3e3e;
}

.error-text {
  color: red;
}
</style>
